var _defs, _g, _line;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBuilding(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #fff;\n      }\n\n      .st0, .st1, .st2 {\n        stroke: #02222b;\n      }\n\n      .st0, .st1, .st2, .st3 {\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .st0, .st2, .st3 {\n        stroke-width: 6.5px;\n      }\n\n      .st1 {\n        stroke-width: 5px;\n      }\n\n      .st1, .st2, .st3 {\n        fill: none;\n      }\n\n      .st3 {\n        stroke: #047290;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.4,92.5V10.8c0-1.9,1.5-3.4,3.4-3.4h48.7c1.9,0,3.4,1.5,3.4,3.4v81.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "39.8 92.5 39.8 70.4 62.8 70.4 62.8 92.6"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 35.7,
    y1: 19.6,
    x2: 35.7,
    y2: 25.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 50,
    y1: 19.6,
    x2: 50,
    y2: 25.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 64.3,
    y1: 19.6,
    x2: 64.3,
    y2: 25.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 35.7,
    y1: 34.8,
    x2: 35.7,
    y2: 41
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 50,
    y1: 34.8,
    x2: 50,
    y2: 41
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 64.3,
    y1: 34.8,
    x2: 64.3,
    y2: 41
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 35.7,
    y1: 50,
    x2: 35.7,
    y2: 56.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 50,
    y1: 50,
    x2: 50,
    y2: 56.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 64.3,
    y1: 50,
    x2: 64.3,
    y2: 56.2
  })), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 51.3,
    y1: 71.6,
    x2: 51.3,
    y2: 92.5
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 14,
    y1: 93.6,
    x2: 86,
    y2: 93.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/building.cf3ba27d6d11652063a82f971defa86c.svg";
export { ForwardRef as ReactComponent };